"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var makeStyle = function makeStyle()
/*{globalVariables={}}={}*/
{
  return {
    Icon: {
      width: 20,
      display: 'inline-block',
      "float": 'left',
      marginRight: 10,
      '& svg path': {
        fill: '#7e7e7e'
      }
    }
  };
};

var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=style.js.map